import React from 'react';
import { Web3Provider } from '../providers/Web3Provider';
import AgentCommerceContent from './AgentCommerceContent';

// Wagmi + RainbowKit wrapper for the Agent Commerce page.
// All state / logic lives in AgentCommerceContent; Web3Provider supplies the wallet context.
const AgentCommercePage = () => (
  <Web3Provider>
    <AgentCommerceContent />
  </Web3Provider>
);

export default AgentCommercePage;
